/* Polyfills
 ---------------------------------------------------------- */
import './polyfill/_assign'
import './polyfill/_entries'
import './polyfill/_isnan'
import './polyfill/_repeat'
import './polyfill/_for-each'

/* Modules
 ---------------------------------------------------------- */
import LazyLoad from './modules/_lazy-load'
import Navigation from './modules/_navigation'
import Print from './modules/_print'
import Accordion from './modules/_accordion'
import NavSearch from './modules/_nav-search'
import Filters from './modules/_filters'
import ShareButtons from './modules/_share-buttons'
import Modals from './modules/_modal'
import NewsSlider from './modules/_news-slider'
import TabFocus from './modules/_tab-focus'
import KultuNaut from './modules/_kultunaut'
import TagEmbed from './modules/_tagembed'
import Archive from './modules/_archive'
import SearchWordSuggest from './modules/_search_word_suggest'
import SmoothScrollOnLoad from './modules/_smooth-scroll-on-load'
import FeaturedSlider from './modules/_featured-slider'
import ObjectFitClass from './utils/_object-fit'
import ModalBox from './utils/_modal-box'
import Hearings from './modules/_hearings'
import SidebarWithTableOfContents from './modules/_sidebar-with-table-of-contents'
import { SmoothScroll } from './modules/_smooth-scroll'

/* Vendor
 ---------------------------------------------------------- */

/* Register modules
 ---------------------------------------------------------- */

let lazyLoad = new LazyLoad();
let navigation = new Navigation();

(function() {
  new SmoothScrollOnLoad().ready();
  new Archive().ready();
  new FeaturedSlider().ready();
  new NavSearch().ready();
  new Print().ready();
  new SearchWordSuggest().ready();
  new ShareButtons().ready();
  new TabFocus().ready();
  new TagEmbed().ready();
  new Accordion().ready();
  new Hearings().ready();
  new SidebarWithTableOfContents().ready()
  SmoothScroll()

  Filters()
  lazyLoad.ready()
  navigation.ready()

  new NewsSlider().initSliders()
  new ObjectFitClass()
  new ModalBox('.open-video-modal')
  Modals()
})()

new KultuNaut().boot()
lazyLoad.boot()
navigation.boot()

require('./app')
